import { Suspense, lazy } from 'react';
import LoadingIndicator from '../common/Loading';

const Settings = lazy(() => import('../components/Settings'));

const SettingsLazy: React.FC = () => {
    return (
        <Suspense fallback={<LoadingIndicator />}>
            <Settings />
        </Suspense>
    );
};

export default SettingsLazy;
